import Box from '@mui/material/Box';

import { Order } from '~hooks/useOrders/models';

import { TicketSummaryQueryContextProvider } from './tickets-table/TicketSummaryQueryContext/TicketSummaryQueryContext';
import TicketsTable from './TicketsTable';
import VendorTicketsSummary from './vendor-tickets-table/VendorTicketsSummary';

interface OrderTicketsProps {
  order: Order;
}

const OrderTickets = ({ order }: OrderTicketsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
      }}
    >
      <TicketSummaryQueryContextProvider orderId={order.id}>
        <Box sx={{ width: '70%', pr: 2 }}>
          <TicketsTable order={order} />
        </Box>
        <Box sx={{ width: '30%' }}>
          <VendorTicketsSummary order={order} />
        </Box>
      </TicketSummaryQueryContextProvider>
    </Box>
  );
};

export default OrderTickets;
